import { render, staticRenderFns } from "./DocumentDrawer.vue?vue&type=template&id=5ffd4ade&scoped=true&"
import script from "./DocumentDrawer.vue?vue&type=script&lang=ts&"
export * from "./DocumentDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentDrawer.vue?vue&type=style&index=0&id=5ffd4ade&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffd4ade",
  null
  
)

export default component.exports